import type { PortalPhase } from '../api/contracts'
import { portalMessageMeta, portalWhen, showPortalDot } from '../lib/portalPhase'
import { Tooltip } from './ui'
import './shared.css'

/**
 * «!» accanto allo stato della pratica finché la card sul portale è in una fase operativa: il CRM traduce le fasi del portale
 * nei suoi stati, il dettaglio (mouse, tastiera o tocco) dà la fase vera e gli ultimi due messaggi della chat della card.
 */
export function PortalPhaseDot({ phase }: { phase: PortalPhase | null | undefined }) {
  if (!showPortalDot(phase)) return null
  const detail = (
    <span className="ecrm-portal-phase">
      <strong>Sul portale: {phase.fase}</strong>
      {phase.messaggi.length === 0
        ? <span className="ecrm-portal-phase__meta">Nessun messaggio nella chat della card.</span>
        : phase.messaggi.map(m => (
          <span key={`${m.il}-${m.testo.slice(0, 20)}`} className="ecrm-portal-phase__msg">
            <span className="ecrm-portal-phase__meta">{portalMessageMeta(m)}</span>
            <span>{m.testo}</span>
          </span>
        ))}
      {phase.aggiornataIl && <span className="ecrm-portal-phase__meta">Letto dal portale il {portalWhen(phase.aggiornataIl)}</span>}
    </span>
  )
  return (
    <Tooltip label={detail} toggleOnClick>
      <button type="button" className="ecrm-portal-dot" aria-label={`Dettaglio dal portale: ${phase.fase}`}>!</button>
    </Tooltip>
  )
}
